// Rule-based auto-tag suggestion engine aligned to Disability Confident scheme taxonomy

const TAG_TAXONOMY = [
  { tag: 'Recruitment Policy', keywords: ['recruit', 'hiring', 'vacancy', 'job advert', 'application', 'interview', 'selection'] },
  { tag: 'Reasonable Adjustments', keywords: ['adjustment', 'reasonable', 'accommodation', 'adapt', 'modification'] },
  { tag: 'Return-to-Work', keywords: ['return', 'rtw', 'absence', 'sick', 'rehabilitation', 'reintegration'] },
  { tag: 'Training Records', keywords: ['training', 'learning', 'course', 'certificate', 'cpd', 'development', 'awareness'] },
  { tag: 'Disability Awareness', keywords: ['disability', 'awareness', 'inclusion', 'inclusive', 'diverse', 'diversity'] },
  { tag: 'Workplace Health & Wellbeing', keywords: ['wellbeing', 'health', 'mental', 'wellness', 'occupational', 'eap'] },
  { tag: 'Level 1 Commitment', keywords: ['level 1', 'committed', 'commitment', 'sign up', 'pledge'] },
  { tag: 'Level 2 Self-Assessment', keywords: ['level 2', 'self assessment', 'self-assessment', 'employer', 'operational'] },
  { tag: 'Level 3 Validation', keywords: ['level 3', 'leader', 'validation', 'external', 'audit', 'accreditation'] },
  { tag: 'Guaranteed Interview Scheme', keywords: ['guaranteed interview', 'gis', 'guaranteed', 'interview scheme'] },
  { tag: 'Retention & Career Development', keywords: ['retention', 'career', 'progression', 'promote', 'develop'] },
  { tag: 'ESG Reporting', keywords: ['esg', 'social value', 'reporting', 'sustainability', 'impact', 'annual report'] },
  { tag: 'Policy Document', keywords: ['policy', 'procedure', 'framework', 'guideline', 'standard', 'protocol'] },
  { tag: 'Data & Metrics', keywords: ['data', 'metric', 'statistic', 'analytics', 'measure', 'kpi', 'survey'] },
  { tag: 'Line Manager Guidance', keywords: ['manager', 'line manager', 'supervisor', 'management guidance'] },
];

export function suggestTags(fileName, fileType) {
  const text = (fileName + ' ' + (fileType || '')).toLowerCase();
  const suggestions = [];

  for (const { tag, keywords } of TAG_TAXONOMY) {
    if (keywords.some(k => text.includes(k))) {
      suggestions.push(tag);
    }
  }

  // Default fallback
  if (suggestions.length === 0) {
    if (fileType?.includes('pdf')) suggestions.push('Policy Document');
    else if (fileType?.includes('word') || fileType?.includes('doc')) suggestions.push('Policy Document');
    else if (fileType?.includes('image') || fileType?.includes('png') || fileType?.includes('jpg')) suggestions.push('Evidence Record');
  }

  return [...new Set(suggestions)];
}

export const ALL_TAGS = TAG_TAXONOMY.map(t => t.tag);